import { Component, inject, signal, computed, ChangeDetectionStrategy } from '@angular/core';
import { CookieConsentService } from '../../../core/services/cookie-consent.service';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-cookie-consent-banner',
  templateUrl: './cookie-consent-banner.component.html',
  styleUrls: ['./cookie-consent-banner.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule],
})
export class CookieConsentBannerComponent {
  private cookieConsentService = inject(CookieConsentService);

  protected showBanner = computed(() => this.cookieConsentService.consentStatus() === null);
  protected showSettings = signal(false);
  protected analyticsEnabled = this.cookieConsentService.analyticsEnabled;

  protected closingBanner = signal(false);
  protected closingModal = signal(false);

  accept() {
    this.cookieConsentService.acceptAll();
  }

  reject() {
    this.cookieConsentService.rejectNonEssential();
  }

  openSettings() {
    this.showSettings.set(true);
  }

  closeSettings() {
    this.closingModal.set(true);
    setTimeout(() => {
      this.showSettings.set(false);
      this.closingModal.set(false);
    }, 200);
  }

  toggleAnalytics() {
    this.analyticsEnabled.set(!this.analyticsEnabled());
  }

  saveSettings() {
    this.cookieConsentService.saveSettings();
    this.showSettings.set(false);
  }
}
